import React from 'react';
import {isFormValid, validated} from 'react-custom-validation';
import PropTypes from 'prop-types';
import update from "immutability-helper";
import { Link } from 'react-router-dom';

// import MediaQuery from 'react-responsive';

import { isEmail, isRequired } from '../../util/validations';
import { handleTextChange } from '../../util/handle-changes';

// import { breakpoints } from '../../util/constants';

// import ActivityIndicator from '../../_components/FormComponents/ActivityIndicator';
import Button from '../../_components/FormComponents/Button';
import Form from '../../_components/FormComponents/Form';
import FormValidationMessage from '../../_components/FormComponents/FormValidationMessage';
import FormRow from '../../_components/FormComponents/FormRow';
// import H2 from '../../_components/FormComponents/H2';
// import H6 from '../../_components/FormComponents/H6';
import Textbox from '../../_components/FormComponents/Textbox';

class ForgotPasswordForm extends React.Component {
    static propTypes = {
        credentials: PropTypes.object.isRequired,
        error: PropTypes.object,
        isSendingForgotPasswordEmail: PropTypes.bool.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        setCredentials: PropTypes.func.isRequired,
    };

    handleChange = (name, value) => {
        let newCredentialsObj = update(this.props.credentials, {});
        newCredentialsObj[name] = value;
        this.props.setCredentials(newCredentialsObj);
    };

    render() {
        let { credentials, error, isSendingForgotPasswordEmail, handleSubmit, renderHelpText, $field, $validation } = this.props;
        const HelpText = renderHelpText || null;

        return (
            <Form className="auth-page__form">

                <FormRow>
                    <Textbox
                        id="txtEmailAddress"
                        label="Email"
                        labelHidden
                        name="email"
                        placeholder="Email (Required)"
                        required
                        type="email"
                        validation={$validation.email}
                        value={credentials.email || ''}
                        {...$field('email', (event) => handleTextChange(this.handleChange, event))}
                    />
                </FormRow>

                {error && Object.keys(error).length > 0 ? (
                    <FormRow className="error-message">
                        <FormValidationMessage>
                            {error.friendlyMessage || error.message}
                        </FormValidationMessage>
                    </FormRow>
                ) : null}

                {renderHelpText && (
                    <HelpText />
                )}

                <div className="auth-page__form__footer">
                    <p className="auth-page__help-text">
                        <Link to="/login">Login</Link>
                    </p>
                    <FormRow className="c-form__button-wrapper">
                        <Button disabled={isFormValid($validation) !== true || isSendingForgotPasswordEmail === true}
                                className='c-button--block'
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.props.$submit(() => handleSubmit(true), () => handleSubmit(false));
                                }}
                                showActivityIndicator={isSendingForgotPasswordEmail}
                                type="submit">
                            Submit
                        </Button>
                    </FormRow>
                </div>

            </Form>
        )
    }
}

function forgotPasswordFormValidationConfig(props) {
    const { email } = props.credentials;

    return {
        fields: ['email'],
        validations: {
            email: [
                [isRequired, email],
                [isEmail, email]
            ]
        }
    }
}

export default ForgotPasswordForm = validated(forgotPasswordFormValidationConfig)(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/ForgotPasswordForm.js